<template>
  <div class="w-full bg-white font-poppins">
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      :title="tittle"
      @close="closeToast"
    />
    <ConfirmCancelModal 
      :is-visible="showCancelModal"
      @cancel="showCancelModal = false"
      @confirm="confirmCancelSuscription"
    />
    <div v-show="!showPayments">
      <!-- LOADER -->
      <div v-if="loader_profile" class="fixed inset-0 flex items-center justify-center bg-white z-50">
        <img
          src="@/assets/imgs/tuin_loader_v2.gif"
          alt="cargando..."
          class="w-[500px]"
        >
      </div>
      <!-- LOADER -->
      <div v-if="!loader_profile" class="relative">
        <div class="flex items-center justify-center">
          <div class="p-4">
            <div class="flex">
              <div class="self-stretch h-8 justify-center text-black text-lg font-medium font-['Poppins'] leading-snug">
                Suscripciones
              </div>
            </div>
            <div class="mt-4 sm:mt-1">
              <div class="h-8 justify-center text-neutral-500 text-base font-medium font-['Poppins'] leading-tight">
                <span>
                  No tienes ninguna suscripción activa en este momento. <br> ¡Comienza ahora para disfrutar de todos nuestros beneficios!
                </span>   
              </div>
            </div>
            <div class="p-4 flex flex-col items-center">
              <div class="w-72 h-64 relative overflow-hidden mt-8">
                <img
                  src="@/assets/imgs/icons/Home_pagos.svg"
                  alt="Pagos"
                  class="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="p-4 flex flex-col items-center">
          <fwb-button
            @click="triggerPlanesTab"
            :disabled="!isActiveLocation"
            class="w-72 px-5 py-2.5 bg-rose-500 rounded-lg outline outline-1 outline-offset-[-1px] outline-rose-500 inline-flex justify-center items-center gap-2 overflow-hidden disabled:opacity-50 cursor-pointer"
          >
            <div class="w-5 h-5 relative overflow-hidden">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="white" class="w-5 h-5">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.5 5.5C10.7652 5.5 11.0196 5.60536 11.2071 5.79289C11.3946 5.98043 11.5 6.23478 11.5 6.5V9.5H14.5C14.7652 9.5 15.0196 9.60536 15.2071 9.79289C15.3946 9.98043 15.5 10.2348 15.5 10.5C15.5 10.7652 15.3946 11.0196 15.2071 11.2071C15.0196 11.3946 14.7652 11.5 14.5 11.5H11.5V14.5C11.5 14.7652 11.3946 15.0196 11.2071 15.2071C11.0196 15.3946 10.7652 15.5 10.5 15.5C10.2348 15.5 9.98043 15.3946 9.79289 15.2071C9.60536 15.0196 9.5 14.7652 9.5 14.5V11.5H6.5C6.23478 11.5 5.98043 11.3946 5.79289 11.2071C5.60536 11.0196 5.5 10.7652 5.5 10.5C5.5 10.2348 5.60536 9.98043 5.79289 9.79289C5.98043 9.60536 6.23478 9.5 6.5 9.5H9.5V6.5C9.5 6.23478 9.60536 5.98043 9.79289 5.79289C9.98043 5.60536 10.2348 5.5 10.5 5.5Z"
                />
              </svg>
            </div>
            <span class="justify-start text-white text-sm font-medium font-['Inter'] leading-tight">
              Activar suscripción
            </span>
          </fwb-button>
        </div>
      </div>
    </div>

    <div v-if="showPayments"> 
      <!-- Plan Free -->
      <div v-if="type_plan === 9" class="flex flex-col items-center justify-center px-4 py-8">
        <div class="w-full max-w-2xl">
          <div class="text-center mb-8">
            <div class="text-rose-500 text-2xl font-medium font-['Poppins'] mb-2">
              Tu negocio está en marcha
            </div>
            <div class="text-neutral-500 text-base font-medium font-['Poppins']">
              Actualmente usas la versión básica. Para publicar más propiedades y acceder a herramientas avanzadas de venta, sube de nivel.
            </div>
          </div>

          <div class="w-full p-8 bg-white rounded-2xl shadow-md outline outline-1 outline-gray-200 mb-6">
            <div class="flex flex-col items-center gap-6">
              <div class="w-32 h-32">
                <img
                  src="@/assets/imgs/icons/Home_pagos.svg"
                  alt="Plan Free"
                  class="w-full h-full object-contain"
                />
              </div>

              <div class="w-full">
                <div class="text-gray-900 text-lg font-medium font-['Poppins'] mb-4 text-center">
                  Tu plan incluye:
                </div>
                <div class="flex flex-col gap-3">
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-gray-400 rounded-sm"></div>
                    </div>
                    <div class="text-gray-500 text-base font-normal font-['Poppins']">
                      Acceso a las funciones básicas.
                    </div>
                  </div>
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-gray-400 rounded-sm"></div>
                    </div>
                    <div class="text-gray-500 text-base font-normal font-['Poppins']">
                      Vizualización de la bolsa inmobiliaria de TUIN
                    </div>
                  </div>
                </div>
              </div>

              <fwb-button
                @click="triggerPlanesTab"
                :disabled="!isActiveLocation"
                class="w-full px-5 py-3 bg-rose-500 rounded-lg flex justify-center items-center gap-2 hover:bg-rose-600 transition-colors"
              >
                <span class="text-white text-base font-medium font-['Poppins']">
                  Elegir un Plan Premium
                </span>
              </fwb-button>

              <div class="text-center text-sm text-gray-500 font-['Poppins']">
                Desbloquea todas las funciones con un plan de pago
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Planes de pago -->
      <div v-else>
        <!-- CUANDO LA SUSCRIPCIÓN ESTÁ ACTIVA: Mostrar cards normales -->
        <div v-if="subscription_status === 'active' && !loader_profile">
          <div class="flex flex-col lg:flex-row justify-start items-start gap-8 lg:gap-[165px] mt-8 lg:mt-10 px-4 sm:px-8 lg:px-[91px]">
            <!-- Sección Izquierda: Detalles de la Cuenta -->
            <div class="w-full lg:w-[492px] inline-flex flex-col justify-start items-start gap-8">
              <div class="self-stretch flex flex-col justify-start items-start gap-4">
                <div class="w-full lg:w-80 flex flex-col justify-start items-start gap-[5px]">
                  <div class="self-stretch h-8 justify-start text-rose-500 text-xl font-medium font-['Poppins'] leading-7">Suscripción Mensual</div>
                  <div class="self-stretch h-8 justify-start text-black text-lg font-medium font-['Poppins'] leading-snug">Detalles de la cuenta</div>
                </div>
              </div>
              <div class="self-stretch min-h-32 bg-white rounded-lg shadow-[0px_2px_4px_-2px_rgba(0,0,0,0.05)] shadow-md overflow-hidden p-4 lg:p-6 flex flex-col justify-between gap-3">
                <div class="flex flex-col gap-2 w-full">
                  <div class="w-full text-black text-lg font-medium font-['Poppins'] leading-snug break-words">{{ plan_name }}</div>
                  <div v-if="!scheduled_cancellation" class="w-full text-black text-sm font-medium font-['Poppins'] leading-tight">
                    <span v-if="payment_source != 'SPEI'">
                      Tu próxima renovación automática es el {{ next_payment }}
                    </span>
                    <span v-else>
                      Recuerda que tu suscripción vence el {{ next_payment }}. Haz tu pago por transferencia para continuar disfrutando del servicio.
                    </span>
                  </div>
                  <div v-else class="w-full text-red-600 text-sm font-medium font-['Poppins'] leading-tight">Tu plan terminará el {{ next_payment }}, aún puedes disfrutar de tus beneficios hasta esa fecha.</div>
                </div>
                <div class="flex items-center gap-3 w-full">
                  <div class="w-10 h-10 flex items-center justify-center flex-shrink-0">
                    <img
                      :src="getCardLogo(type_card)"
                      alt="Card Logo"
                      class="w-10 h-auto object-contain"
                    />
                  </div>
                  <div class="text-black text-base font-medium font-['Poppins'] leading-tight">**** **** **** {{ last4_number }}</div>
                </div>

                <div v-if="payment_source != 'SPEI'" class="flex flex-col gap-2 w-full mt-2">
                  <button
                    @click="updatePaymentMethod"
                    class="text-gray-600 text-sm font-medium font-['Poppins'] underline hover:text-gray-700 transition-colors text-left"
                  >
                    Actualizar datos de facturación
                  </button>
                </div>
              </div>
            </div>
            
            <!-- Sección Derecha: Card del Plan -->
            <div class="w-full lg:w-96 p-6 sm:p-8 bg-white rounded-2xl shadow-[0px_2px_4px_-2px_rgba(0,0,0,0.05)] shadow-md outline outline-1 outline-offset-[-1px] outline-gray-200 flex flex-col justify-start items-center gap-6 sm:gap-7 overflow-hidden">
              <div class="flex flex-col items-center sm:items-start w-full gap-4">
                <div class="text-gray-500 text-lg sm:text-xl font-medium font-['Poppins'] leading-snug text-center sm:text-left">
                  {{ plan_name }}
                </div>

                <div class="flex flex-wrap justify-center sm:justify-start items-end gap-1.5 sm:gap-2.5">
                  <div class="text-gray-900 text-4xl sm:text-5xl font-extrabold font-['Poppins'] leading-[40px] sm:leading-[48px]">
                    ${{ plan_price }}
                  </div>
                  <div class="text-gray-500 text-base sm:text-lg font-medium font-['Poppins'] leading-relaxed">
                    /{{ billing_cycle }}
                  </div>
                </div>
              </div>

              <div class="w-full flex flex-col justify-start items-start gap-3 sm:gap-4">
                <div
                  v-for="(benefit, i) in [
                    propertyLimit,
                    'Exposición automática en 6 portales',
                    'Contacto Directo Sin Intermediarios',
                    'Presencia Profesional Digital',
                    'Optimización y Estadísticas Completas',
                    'Difusión orgánica en redes sociales de Tuin',
                    'Tu propio sitio web personal e inmobiliria disponible en Tuin'
                  ]"
                  :key="i"
                  class="flex items-center gap-3 w-full"
                >
                  <div class="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                    <div class="w-3 h-3 sm:w-3.5 sm:h-3.5 bg-rose-500 rounded-sm"></div>
                  </div>
                  <div class="flex-1 text-gray-500 text-sm sm:text-base font-normal font-['Poppins'] leading-normal">
                    {{ benefit }}
                  </div>
                </div>
              </div>

              <fwb-button
                @click="triggerPlanesTab"
                :disabled="!isActiveLocation"
                class="w-full px-4 sm:px-5 py-2 bg-rose-500 rounded-lg flex justify-center items-center gap-2 hover:bg-rose-600 transition-colors"
              >
                <span class="text-white text-sm sm:text-base font-medium font-['Poppins'] leading-tight">
                  Cambiar plan
                </span>
              </fwb-button>
            </div>
          </div>

          <!-- Botón Cancelar Suscripción (solo cuando está activa) -->
          <div v-if="type_plan != 9 && !scheduled_cancellation && payment_source != 'SPEI'" class="px-4 sm:px-8 lg:px-[91px] mt-4">
            <div
              class="w-44 h-5 justify-center text-neutral-500 text-base font-medium font-['Poppins'] underline leading-normal cursor-pointer"
              @click="openCancelModal"
            >
              Cancelar Suscripción
            </div>
          </div>
        </div>

        <!-- CUANDO LA SUSCRIPCIÓN NO ESTÁ ACTIVA: Mostrar alertas centradas en card -->
        <div v-else-if="!loader_profile" class="flex items-center justify-center px-4 py-8 min-h-[400px]">
          <div class="w-full max-w-2xl">
            <!-- Estado: Failed -->
            <div v-if="subscription_status === 'failed'" class="w-full p-6 sm:p-8 bg-white rounded-2xl shadow-md outline outline-1 outline-offset-[-1px] outline-gray-200 flex flex-col justify-start items-start gap-6">
              <div class="flex items-start gap-4 w-full">
                <div class="w-12 h-12 flex-shrink-0 bg-rose-100 rounded-full flex items-center justify-center">
                  <svg class="w-6 h-6 text-rose-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="text-gray-900 text-lg font-medium font-['Poppins'] mb-2">
                    Actualiza tu método de pago para evitar interrupciones
                  </div>
                  <div class="text-gray-600 text-base font-normal font-['Poppins']">
                    Hubo un problema con tu último cargo. Lo reintentaremos automáticamente, pero te recomendamos revisar tus datos para que tus propiedades no dejen de visualizarse.
                  </div>
                </div>
              </div>
              <fwb-button
                @click="updatePaymentMethod"
                class="w-full sm:w-auto px-5 py-3 bg-rose-500 rounded-lg hover:bg-rose-600 transition-colors"
              >
                <span class="text-white text-base font-medium font-['Poppins']">
                  Actualizar método de pago
                </span>
              </fwb-button>
            </div>

            <!-- Estado: Canceled por falta de pago -->
            <div v-else-if="subscription_status === 'canceled' && failure_reason === 'invoice_payment_failed'" class="w-full p-6 sm:p-8 bg-white rounded-2xl shadow-md outline outline-1 outline-offset-[-1px] outline-gray-200 flex flex-col justify-start items-start gap-6">
              <div class="flex items-start gap-4 w-full">
                <div class="w-12 h-12 flex-shrink-0 bg-red-100 rounded-full flex items-center justify-center">
                  <svg class="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="text-gray-900 text-lg font-medium font-['Poppins'] mb-2">
                    Suscripción suspendida por falta de pago
                  </div>
                  <div class="text-gray-600 text-base font-normal font-['Poppins']">
                    Actualiza tu método de pago para reactivar tu suscripción y continuar disfrutando de todos los beneficios.
                  </div>
                </div>
              </div>
              <fwb-button
                @click="updatePaymentMethod"
                class="w-full sm:w-auto px-5 py-3 bg-rose-500 rounded-lg hover:bg-rose-600 transition-colors"
              >
                <span class="text-white text-base font-medium font-['Poppins']">
                  Actualizar método de pago
                </span>
              </fwb-button>
            </div>
            
            <!-- Estado: Expired SPEI + propiedades ya desactivadas (5+ días sin renovar) -->
            <div
              v-else-if="subscription_status === 'expired' && payment_source === 'SPEI' && properties_deactivated_at"
              class="w-full p-6 sm:p-8 bg-white rounded-2xl shadow-md outline outline-1 outline-offset-[-1px] outline-gray-200 flex flex-col justify-start items-start gap-6"
            >
              <div class="flex items-start gap-4 w-full">
                <div class="w-12 h-12 flex-shrink-0 bg-red-100 rounded-full flex items-center justify-center">
                  <svg class="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="text-gray-900 text-lg font-medium font-['Poppins'] mb-2">
                    Tus propiedades fueron desactivadas
                  </div>
                  <div class="text-gray-600 text-base font-normal font-['Poppins'] mb-3">
                    Pasaron más de 5 días desde que tu suscripción venció sin detectarse un pago de renovación,
                    por lo que tus propiedades se desactivaron automáticamente y dejaron de ser visibles.
                  </div>
                  <div class="text-gray-600 text-base font-normal font-['Poppins']">
                    Para reactivarlas, renueva tu suscripción por transferencia o cambia a pago automático con tarjeta.
                  </div>
                </div>
              </div>

              <div class="bg-red-50 p-4 rounded-lg border border-red-200 w-full">
                <div class="text-red-700 text-sm font-medium font-['Poppins'] mb-1">
                  ¿Ya hiciste tu transferencia?
                </div>
                <div class="text-red-600 text-sm font-normal font-['Poppins']">
                  Comparte tu comprobante por WhatsApp y activaremos tus propiedades de inmediato.
                </div>
              </div>

              <div class="bg-gray-50 p-4 rounded-lg border border-gray-200 w-full">
                <div class="text-gray-900 text-sm font-medium font-['Poppins'] mb-3">
                  Datos para transferencia:
                </div>
                <div class="text-gray-600 text-sm font-normal font-['Poppins'] space-y-1.5">
                  <div><span class="font-medium text-gray-700">Beneficiario:</span> TUIN INNOVACION INMOBILIARIA SAPI de CV</div>
                  <div><span class="font-medium text-gray-700">CLABE:</span> 99180600006125681</div>
                  <div><span class="font-medium text-gray-700">Banco:</span> Fondeadora</div>
                </div>
              </div>

              <div class="flex flex-col sm:flex-row gap-3 w-full">
                <fwb-button
                  @click="openWhatsApp"
                  class="flex-1 px-5 py-3 bg-white border border-green-600 rounded-lg hover:bg-green-50 transition-colors flex items-center justify-center gap-2"
                >
                  <svg class="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                  <span class="text-green-600 text-base font-medium font-poppins">
                    Enviar comprobante
                  </span>
                </fwb-button>
                <fwb-button
                  @click="triggerPlanesTab"
                  class="w-full sm:w-auto px-5 py-3 bg-rose-500 rounded-lg hover:bg-rose-600 transition-colors"
                >
                  <span class="text-white text-base font-medium font-['Poppins']">
                    Cambiar a pago automático
                  </span>
                </fwb-button>
              </div>
            </div>

            <!-- Estado: Expired con SPEI -->
            <div v-else-if="subscription_status === 'expired' && payment_source === 'SPEI'" class="w-full p-6 sm:p-8 bg-white rounded-2xl shadow-md outline outline-1 outline-offset-[-1px] outline-gray-200 flex flex-col justify-start items-start gap-6">
              <div class="flex items-start gap-4 w-full">
                <div class="w-12 h-12 flex-shrink-0 bg-rose-100 rounded-full flex items-center justify-center">
                  <svg class="w-6 h-6 text-rose-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"/>
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="text-gray-900 text-lg font-medium font-['Poppins'] mb-2">
                    Es momento de renovar tu suscripción
                  </div>
                  <div class="text-gray-600 text-base font-normal font-['Poppins'] mb-4">
                    Puedes renovar tu suscripción mediante transferencia bancaria.
                  </div>
                  
                  <div class="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-4">
                    <div class="text-gray-900 text-sm font-medium font-['Poppins'] mb-3">
                      Datos para transferencia:
                    </div>
                    <div class="text-gray-600 text-sm font-normal font-['Poppins'] space-y-1.5">
                      <div><span class="font-medium text-gray-700">Beneficiario:</span> TUIN INNOVACION INMOBILIARIA SAPI de CV</div>
                      <div><span class="font-medium text-gray-700">CLABE:</span> 99180600006125681</div>
                      <div><span class="font-medium text-gray-700">Banco:</span> Fondeadora</div>
                    </div>
                  </div>

                  <div class="text-gray-600 text-sm font-normal font-['Poppins']">
                    Después de realizar tu transferencia, comparte tu comprobante con nuestro equipo a través de WhatsApp para activar tu cuenta de inmediato.
                  </div>
                </div>
              </div>
              
              <div class="flex flex-col sm:flex-row gap-3 w-full">
                <fwb-button
                  @click="openWhatsApp"
                  class="flex-1 px-5 py-3 bg-white border border-green-600 rounded-lg hover:bg-green-50 transition-colors flex items-center justify-center gap-2"
                >
                  <svg class="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                  <span class="text-green-600 text-base font-medium font-poppins">
                    Enviar comprobante
                  </span>
                </fwb-button>
                <fwb-button
                  @click="triggerPlanesTab"
                  class="w-full sm:w-auto px-5 py-3 bg-rose-500 rounded-lg hover:bg-rose-600 transition-colors"
                >
                  <span class="text-white text-base font-medium font-['Poppins']">
                    Cambiar a pago automático
                  </span>
                </fwb-button>
              </div>
            </div>

            <!-- Estado: Canceled (sin falta de pago) -->
            <div v-else-if="subscription_status === 'canceled'" class="w-full p-6 sm:p-8 bg-white rounded-2xl shadow-md outline outline-1 outline-offset-[-1px] outline-gray-200 flex flex-col justify-start items-start gap-6">
              <div class="flex items-start gap-4 w-full">
                <div class="w-12 h-12 flex-shrink-0 bg-gray-100 rounded-full flex items-center justify-center">
                  <svg class="w-6 h-6 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/>
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="text-gray-900 text-lg font-medium font-['Poppins'] mb-2">
                    Tu suscripción fue cancelada
                  </div>
                  <div class="text-gray-600 text-base font-normal font-['Poppins']">
                    Contrata un nuevo plan para seguir disfrutando de todos los beneficios de Tuin.
                  </div>
                </div>
              </div>
              <fwb-button
                @click="triggerPlanesTab"
                :disabled="!isActiveLocation"
                class="w-full sm:w-auto px-5 py-3 bg-rose-500 rounded-lg hover:bg-rose-600 transition-colors"
              >
                <span class="text-white text-base font-medium font-['Poppins']">
                  Contratar un nuevo plan
                </span>
              </fwb-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from "vue";
  import { useStore } from "vuex";
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  import { useRouter } from "vue-router";
  let router = useRouter();
  import axios from "axios";
  import { defineEmits } from 'vue';
  
  import { defineProps } from "vue";
  import ConfirmCancelModal from "./modal/confirmCanceledSuscription.vue";

  const emit = defineEmits(['updateSubscription']);
  const props = defineProps({
    userdata: {
      type: Object,
      required: true,
    },
  });
  
  let showPayments = ref(false);
  let plan_name = ref();
  const showCancelModal = ref(false);
  let id_suscription = ref(null);
  let next_payment = ref();
  let toastAlert = ref(false);
  let typeMsg = ref("");
  let msg = ref("");
  let tittle = ref("")
  let plan_price = ref();
  let type_plan = ref();
  let last4_number = ref();
  let type_card = ref();
  let billing_cycle = ref();
  let loader_profile = ref(false);
  let scheduled_cancellation = ref(0);
  let subscription_status = ref('active'); // active, failed, canceled, expired
  let payment_source = ref(''); // card, spei
  let failure_reason = ref('');
  let properties_deactivated_at = ref(null);

  const propertyPlans = {
    149: "Hasta 3 propiedades",
    199: "Hasta 5 propiedades",
    399: "Hasta 10 propiedades",
    499: "Propiedades ilimitadas",
    1430: "Hasta 3 propiedades",
    1910: "Hasta 5 propiedades",
    3830: "Hasta 10 propiedades",
    4790: "Propiedades ilimitadas",
  };

  async function getSubscription(userFromParent) {
    try {
      loader_profile.value = true;

      // ✅ Si no tiene stripe_customer_id, igual revisamos si tiene suscripción local
      if (!userFromParent?.info.stripe_customer_id) {
        console.log("Usuario no tiene Stripe ID — Revisando suscripción local...");

        const options = {
          headers: {
            Authorization: `Bearer ${session.value.token_api}`,
          },
        };

        try {
          const response = await axios.get(
            `${process.env.VUE_APP_API_BASE_URL}/broker/getSubscription/${session.value.id}`,
            options
          );

          // Si la suscripción está activa → la mostramos
          if (response.status === 200 && response.data.status === "active") {
            plan_price.value = new Intl.NumberFormat('es-MX', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(response.data.data.amount);
            type_plan.value = response.data.data.plan_id;
            scheduled_cancellation.value = response.data.data.scheduled_cancellation;
            subscription_status.value = response.data.statuss || 'active';
            payment_source.value = userFromParent?.info.last_subscription.source || 'card';
            failure_reason.value = userFromParent?.info.last_subscription.failure_reason || '';
            properties_deactivated_at.value = response.data.data?.properties_deactivated_at || null;
            plan_name.value = response.data.data.plan?.name || "Plan Business";
            next_payment.value = formatDate(response.data.data.ends_at);
            last4_number.value = response.data.data.card_last4;
            type_card.value = response.data.data.card_brand;
            billing_cycle.value = response.data.data.billing_cycle === "monthly"
              ? "mensual"
              : response.data.data.billing_cycle === "annual"
              ? "anual"
              : response.data.data.billing_cycle;
            id_suscription.value = response.data.data.stripe_subscription_id;
            showPayments.value = true;
          } else {
            subscription_status.value = response.data.status || 'active';
            payment_source.value = userFromParent?.info.last_subscription.source || 'card';
            failure_reason.value = userFromParent?.info.last_subscription.failure_reason || '';
            properties_deactivated_at.value = userFromParent?.info.last_subscription?.properties_deactivated_at || null;
            if (subscription_status.value === 'expired' && payment_source.value != 'SPEI') {
              showPayments.value = false;
            }else{
              showPayments.value = true;
            }
          }

        } catch (error) {
          console.log("No se encontró suscripción local:", error);
          showPayments.value = false;
        } finally {
          loader_profile.value = false;
        }

        //Salimos aquí y NO seguimos al flujo stripe
        return;
      }

      const options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };

      // ✅ Sincronizar con Stripe (crear o actualizar si es necesario)
      try {
        await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/broker/stripesave/${session.value.id}`,
          options
        );
      } catch (stripeError) {
        console.log("Error en stripesave:", stripeError);
        // Continuar de todas formas
      }

      // ✅ Traer detalles de suscripción
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/getSubscription/${session.value.id}`,
        options
      );

      if (response.status === 200 && response.data.status === "active") {
        if(response.data.data.plan_id === 9){
          showPayments.value = true;
          type_plan.value = 9;
        }
        else{
          //console.log('respuesta:', response.data)
          plan_price.value = new Intl.NumberFormat('es-MX', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(response.data.data.amount);
          plan_name.value = response.data.data.plan?.name || "Plan Business";
          next_payment.value = formatDate(response.data.data.ends_at);
          last4_number.value = response.data.data.card_last4;
          scheduled_cancellation.value = response.data.data.scheduled_cancellation;
          subscription_status.value = response.data.data.status || 'active';
          payment_source.value = userFromParent?.info.last_subscription.source || 'card';
          failure_reason.value = userFromParent?.info.last_subscription.failure_reason || '';
          properties_deactivated_at.value = userFromParent?.info.last_subscription?.properties_deactivated_at || null;
          type_card.value = response.data.data.card_brand;
          billing_cycle.value = response.data.data.billing_cycle === "monthly"
            ? "mensual"
            : response.data.data.billing_cycle === "annual"
            ? "anual"
            : response.data.data.billing_cycle;
          id_suscription.value = response.data.data.stripe_subscription_id;
          showPayments.value = true;
        }
      } else {
          subscription_status.value = response.data.status || 'active';
          payment_source.value = userFromParent?.info.last_subscription.source || 'card';
          failure_reason.value = userFromParent?.info.last_subscription.failure_reason || '';
          if (subscription_status.value === 'expired' && payment_source.value != 'SPEI') {
            showPayments.value = false;
          }else{
            showPayments.value = true;
          }
      }

    } catch (error) {
      const response = error.response;

      if (response?.status === 401) {
        store.dispatch("clearUserSession");
        router.push({ name: "login" });
      } else {
        console.error("Error fetching subscription:", error);
        showPayments.value = false;
      }

    } finally {
      loader_profile.value = false;
    }
  }

  const getCardLogo = (brand) => {
    switch (brand?.toLowerCase()) {
      case 'visa':
        return require('@/assets/imgs/icons/logos_visa.svg');
      case 'mastercard':
        return require('@/assets/imgs/icons/logos_mastercard.svg');
      default:
        return require('@/assets/imgs/icons/credit-card-credit-svgrepo-com.svg');
    }
  };
  const propertyLimit = computed(() => {
    // Normalizar a número (maneja "149.00", "149", 149, null, etc.)
    const raw = plan_price.value;
    if (raw === null || raw === undefined || raw === "") return "Sin propiedades asignadas";

    const num = Math.round(Number(parseFloat(String(raw).replace(/[^0-9.-]+/g, "")) || 0));

    return propertyPlans[num] || "Sin propiedades asignadas";
  });

  async function triggerPlanesTab() {
    emit('goToPlanes', 'planes'); // enviamos el nombre del tab
  }
  function formatDate(dateString) {
    const date = new Date(dateString);
    const months = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  onMounted(async () => {
    try {
      loader_profile.value = true;
      await getSubscription(props.userdata);
      console.log(subscription_status.value);
      console.log(payment_source.value);
      console.log(failure_reason.value);
    } catch (error) {
      console.error("Error al intentar traer los datos", error);
    }
  });

  async function cancelSuscription(suscription) {
    loader_profile.value = true;
    try {

      const options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };

      // Si NO existe stripe_subscription_id → cancelar por userId
      if (!suscription) {
        await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/broker/cancelSuscriptionByUser/${session.value.id}`,
          options
        );

        showToast(
          "success",
          "Tu suscripción fue marcada para cancelarse al final del periodo (cancelación local)."
        );

        // 🔥 Recargar después del éxito
        setTimeout(() => location.reload(), 200);

        return;
      }

      // Si sí existe → cancelar con Stripe
      await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/cancelSuscription/${suscription}`,
        options
      );

      showToast(
        "success",
        "Tu suscripción fue programada para cancelarse al final de tu periodo actual."
      );

      // 🔥 Recargar después del éxito
      setTimeout(() => location.reload(), 200);

    } catch (error) {
      const response = error.response;

      if (response?.status === 401) {
        store.dispatch("clearUserSession");
        router.push({ name: "login" });
      } else {
        console.error("Error fetching subscription:", error);
      }

    } finally {
      loader_profile.value = false;
    }
  }

  function openCancelModal() {
    //plan_name.value = propertyId;
    showCancelModal.value = true;
  }

  const confirmCancelSuscription = async () => {
    showCancelModal.value = false;
    loader_profile.value = true;
    await cancelSuscription(id_suscription.value);
  };

  async function showToast(type = null, message = null, tittl = null) {
    toastAlert.value = true;
    typeMsg.value = type;
    msg.value = message;
    tittle.value = tittl;

    setTimeout(() => {
      closeToast();
    }, 3000);
  }

  async function closeToast() {
    toastAlert.value = false;
    typeMsg.value = "";
    msg.value = "";
  }

  async function updatePaymentMethod() {
    loader_profile.value = true;
    try {
      const options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };

      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/billing/portal/${session.value.id}`,
        options
      );

      if (response.data.url) {
        loader_profile.value = false;
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.error("Error al crear sesión de actualización:", error);
      showToast("error", "No se pudo abrir la página de actualización. Intenta de nuevo.");
    }
  }

  function openWhatsApp() {
    // ⚠️ REEMPLAZA CON EL NÚMERO REAL DE TUIN
    const whatsappNumber = '5215567032976';
    const message = encodeURIComponent('Hola, quiero compartir mi comprobante de pago para renovar mi suscripción en TUIN.');
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${message}`;
    window.open(whatsappURL, '_blank');
  }
</script>

